import PDSBox from 'designSystem/components/PDSBox/PDSBox'
import PDSBreadCrumbs from 'designSystem/components/PDSBreadCrumbs/PDSBreadCrumbs'
import { COLOR } from 'designSystem/foundations/constants/color'
import { SIZE } from 'designSystem/foundations/constants/size'

type PathItem = {
  name: string
  route: string
}

type Props = {
  paths: PathItem[]
}

export default function BreadcrumbBar({ paths }: Props) {
  return (
    <PDSBox
      alignItems="center"
      backgroundColor={COLOR.content}
      borderBottom={`1px solid ${COLOR.content_border}`}
      paddingX={SIZE.s40}
      paddingY={SIZE.s12}
    >
      <PDSBreadCrumbs paths={paths} testId="bread-crumb" />
    </PDSBox>
  )
}
